import React from "react"
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import { Helmet } from "react-helmet"
// Styles
import { Container, Wrapper, StyledIframe } from "./ThreeDView.styles"

const ThreeDView = () => {
   const { t } = useTranslation()
   const location = useLocation()
   const variationCode = location.pathname.split("/")[2]

   return (
      <>
         <Helmet>
            <title>{t("threeDview.meta.meta_title")}</title>
            <meta name="robots" content="noindex, nofollow" />
         </Helmet>
         <Container>
            <Wrapper>
               <StyledIframe
                  src={`/keyshots/${variationCode}/${variationCode}.html`}
                  allow="fullscreen"
               />
            </Wrapper>
         </Container>
      </>
   )
}

export default ThreeDView
